import { useRef, useEffect, useState } from "react"
import { Remarkable } from "remarkable"
import "./case-study-results.component.css"

const md = new Remarkable()

const CaseStudyResultsComponent = (props) => {
  const { Heading, Results, FreeTextCopy, HexColor } = props
  const [isVisible, setIsVisible] = useState(false)
  const ref = useRef(null)

  useEffect(() => {
    const el = ref.current
    if (!el) return

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true)
          observer.unobserve(el)
        }
      },
      { threshold: 0.3 },
    )

    observer.observe(el)
    return () => observer.disconnect()
  }, [])

  return (
    <div
      ref={ref}
      className={`dagger-case-study-results-container ${isVisible ? "dagger-slide-in-visible" : "dagger-slide-in-hidden"}`}
    >
      {Heading && Heading.trim().length > 0 && (
        <h5 style={{ color: HexColor }}>{Heading}</h5>
      )}
      {FreeTextCopy ? (
        <div
          className="dagger-case-study-results-free-text"
          dangerouslySetInnerHTML={{ __html: md.render(FreeTextCopy) }}
        />
      ) : (
        <div className="dagger-case-study-results">
          {Results?.map((p) => {
            return (
              <div className="dagger-case-study-result" key={p.id}>
                <h2>{p.Result}</h2>
                <h5 style={{ color: HexColor }}>{p.Copy}</h5>
              </div>
            )
          })}
        </div>
      )}
    </div>
  )
}

export default CaseStudyResultsComponent
